import { useEffect, useState } from 'react';
import type { Comic } from '@/mocks/comics';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Categories from './components/Categories';
import Featured from './components/Featured';
import Rankings from './components/Rankings';
import Updates from './components/Updates';
import Completed from './components/Completed';
import About from './components/About';
import Faq from './components/Faq';
import Newsletter from './components/Newsletter';
import Footer from './components/Footer';
import ComicModal from './components/ComicModal';

export default function Home() {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedComic, setSelectedComic] = useState<Comic | null>(null);
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 480);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToFeatured = () => {
    document.getElementById('featured')?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleQuickSearch = (term: string) => {
    setSearchTerm(term);
    document.getElementById('featured')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <Navbar
        query={searchTerm}
        onQueryChange={setSearchTerm}
        onSearch={scrollToFeatured}
      />
      <main>
        <Hero
          query={searchTerm}
          onQueryChange={setSearchTerm}
          onSearch={scrollToFeatured}
          onQuickSearch={handleQuickSearch}
        />
        <Categories onSelect={handleQuickSearch} />
        <Featured searchTerm={searchTerm} onSelect={setSelectedComic} />
        <Rankings onSelect={setSelectedComic} />
        <Updates onSelect={setSelectedComic} />
        <Completed onSelect={setSelectedComic} />
        <About />
        <Faq />
        <Newsletter />
      </main>
      <Footer />

      {showTop && (
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="fixed bottom-6 right-6 z-40 w-11 h-11 flex items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg hover:bg-primary-600 cursor-pointer"
          aria-label="返回顶部"
        >
          <i className="ri-arrow-up-line text-lg w-5 h-5 flex items-center justify-center" />
        </button>
      )}

      <ComicModal comic={selectedComic} onClose={() => setSelectedComic(null)} />
    </>
  );
}